import * as Sentry from '@sentry/react';

export const withErrorBoundary = WrappedComponent => props => {
  return (
    <Sentry.ErrorBoundary fallback={<div />}>
      <WrappedComponent {...props} />
    </Sentry.ErrorBoundary>
  );
};
